/*
 * --------------------------------------
 * Copyright (c) 2020 BetterCapital.US
 * --------------------------------------
 */
import React, { Component } from "react";
import { ConnectedRouter } from "connected-react-router";
import jwt_decode from "jwt-decode";
import { Provider } from "react-redux";
import { connect } from "react-redux";
import clsx from "clsx";

import { store, history } from "./store";
import { /* setAuthToken */ Auth } from "./api/agent";
import { logout, logoutMalformed } from "./actions/auth/authAction";
import { LOGOUT_REQUEST } from "./actions/auth/authActionTypes";
import { SET_CURRENT_USER } from "./actions/auth/authActionTypes";
import LoadingIndicator from "./shared/components/LoadingIndicator";
import LogRocket from "logrocket";
import { Modal } from "reactstrap";
import mixpanel from "mixpanel-browser";

import Router from "./Router";
import ScrollToTop from "./ScrollToTop";
import { ToastContainer } from "react-toastify";

import "react-toastify/dist/ReactToastify.css";
import "@zoomus/websdk/dist/css/react-select.css";
import ReactGa from "react-ga";

import "./App.scss";
import "./assets/base.scss";

/** Hotfix css-modal */
Modal.prototype.componentWillUnmount = function() {
  if (this.props.onExit) {
    this.props.onExit();
  }

  if (this._element) {
    this.destroy();
    if (this.props.isOpen || this.state.isOpen) {
      this.close();
    }
  }

  this._isMounted = false;
};
/** Hotfix css-modal */

const validateToken = async (self, token) => {
  //setting auth headers
  // setAuthToken(token);
  let resp = await Auth.validateToken();

  if (resp.success === true) {
    localStorage.setItem("token", resp.user.token);
    const decoded = jwt_decode(resp.user.token);
    store.dispatch({
      type: SET_CURRENT_USER,
      payload: {
        token: resp.user.token,
        picture: decoded.picture,
        fullName: decoded.fullName,
        email: decoded.email,
        id: decoded.id,
        isPartner: decoded.isPartner,
        partnerStatus: decoded.partnerStatus,
        partnerSlug: decoded.partnerSlug
      }
    });

    if (process.env.REACT_APP_CUSTOMERLY_KEY) {
      window.customerlySettings = {
        app_id: process.env.REACT_APP_CUSTOMERLY_KEY,
        user_id: decoded.id,
        name: decoded.fullName,
        email: decoded.email
      };
      window.heap.identify(decoded.id);
      window.heap.addUserProperties({
        Name: decoded.fullName,
        email: decoded.email
      });
    }

    if (process.env.REACT_APP_LOGROCKET_KEY) {
      LogRocket.identify(process.env.REACT_APP_LOGROCKET_KEY, {
        name: decoded.fullName,
        email: decoded.email
      });
    }

    if (process.env.REACT_APP_MIXPANEL_TOKEN) {
      mixpanel.identify(decoded.id);
      mixpanel.people.set({
        $email: decoded.email,
        "Sign up date": decoded.createdAt,
        "Last login": decoded.lastLogin,
        USER_ID: decoded.id
      });
    }

    self.setState({
      loading: false
    });
    return resp;
  } else {
    store.dispatch({
      type: SET_CURRENT_USER,
      payload: {}
    });
    return false;
  }
};

class App extends Component {
  constructor(props) {
    super();
    this.state = {
      loading: true,
      loaded: false
    };
  }

  async componentDidMount() {
    if (process.env.REACT_APP_GOOGLE_ANALYTICS_KEY) {
      ReactGa.initialize(process.env.REACT_APP_GOOGLE_ANALYTICS_KEY);
      history.listen(location => {
        ReactGa.set({ page: location.pathname });
        ReactGa.pageview(location.pathname);
      });
    }

    if (process.env.REACT_APP_MIXPANEL_TOKEN) {
      mixpanel.init(process.env.REACT_APP_MIXPANEL_TOKEN);
    }
    const token = localStorage.getItem("token");
    if (token) {
      var decoded = null;
      try {
        decoded = jwt_decode(token);
      } catch (e) {
        //token is malformed
        // this.props.logout();
        logoutMalformed();
        store.dispatch({
          type: LOGOUT_REQUEST
        });
        window.location = "/login";
      }
      const currentTime = Date.now() / 1000;
      if (decoded && decoded.exp < currentTime) {
        logoutMalformed();
        store.dispatch({
          type: LOGOUT_REQUEST
        });
        window.location = "/login";
      } else {
        //token is still alive.We check its integrity.
        try {
          var yes = await validateToken(this, token);
          if (!yes) {
            this.props.logoutUser();
            // this.props.history.push('/');
            this.setState({ loading: false });
            history.push("/login");
          }

          // store.dispatch({ type: SET_CURRENT_USER, payload: resp.user })
        } catch (err) {
          this.props.logout();
          this.setState({ loading: false });
          history.push("/login");
        }
      }
    } else this.setState({ loading: false });
  }

  render() {
    const { loading } = this.state;

    return (
      <Provider store={store}>
        <ConnectedRouter history={history}>
          <ScrollToTop>
            {loading ? (
              <LoadingIndicator loading={loading} />
            ) : (
              <div
                className={clsx("app-wrapper app-sidebar-fixed", {
                  "app-sidebar-mobile-open": this.props.sidebar.show,
                  "header-drawer-open": this.props.drawerState
                })}
              >
                <ToastContainer />
                <Router />
              </div>
            )}
          </ScrollToTop>
        </ConnectedRouter>
      </Provider>
    );
  }
}
const mapStateToProps = state => ({
  sidebar: state.sidebar,
  drawerState: state.app.drawerState,
  auth: state.login
});
const mapDispatchToProps = dispatch => ({
  logout: () => {
    logout(dispatch);
  }
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(App);
